import Utils from '../../utils/utils.js'
import LogHelper from '../../utils/logHelper.js'
const utilsHelper = new Utils()
import PagePlugin from '../../page_plugin/index.js'

export default class ShoplineTraceService {

    constructor(container_id, config, is_debug, storage_key) {

        this.config = config
        this.container_id = container_id
        this.is_debug = is_debug
        this.storage_key = storage_key
        this.retry_time = 5
        // 一天
        this.expired_min = 1200
        this.logHelper = new LogHelper(config.LOG_LEVEL, config.LOG_ENDPOINT, is_debug, container_id)
        
    }

    run() {

        try {
            // 結帳頁預打購買事件
            if (window.location.href.includes('/checkout')){
                console.log('optimize99_checkout')
                this.prePlaceOrder()
                this.prePlaceOrderBtn()
                if (window.clarity) {
                    window.clarity("upgrade", "checkout_page")
                }
            }

            if (window.location.href.includes('/confirm') && window.location.href.includes('confirmation') === false){
                console.log('optimize99_confirm_order')
                let clid = ''
                try {
                    let s_clid = utilsHelper.getClidByContainerId(this.storage_key)
                    if (s_clid) {
                        clid = s_clid
                    }
                } catch (error) {
                    clid = ''
                }
                this.confirmOrder(clid)
                if (window.clarity) {
                    window.clarity("upgrade", "purchase_page")
                }
            }
        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_shopline_run',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack
                }
            })
            // throw Error(error)
        }

    }

    abTestCallBack(views, clid){
        try {
            console.log('optimize99_callback_shopline:', views)

            // if (views.length === 0 ){
            //     return
            // }

            // 建立加入購物車的事件追蹤
            this.addToCart(views, clid)

        } catch (error) {
            // throw Error(error)
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_shopline_abTestCallBack',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack
                }
            })
        }
    }

    addToCart(views, clid){
        console.log('optimize99_add2cart', views)

        let that = this
        const cart_btn_ids = [
            'btn-add-to-cart', 'btn-main-checkout'
        ]
        const cart_btn_classnames = [
            'btn-cart-fixed', 'js-btn-cart-fixed', 'btn-buy-now', 'btn-buy-now-content'
        ]
        document.addEventListener('click', function(event){
            // console.log('click', event)

            let target_ele = event.target
            if (target_ele instanceof HTMLElement === false) {
                if (target_ele.parentElement instanceof HTMLElement === false) {
                    return
                }
                else {
                    target_ele = target_ele.parentElement 
                }
            }


            let is_match = false

            for(let idx = 0; idx < cart_btn_classnames.length; idx++){
                if (target_ele.closest(`.${cart_btn_classnames[idx]}`)){
                    is_match = true
                    break
                } 
            }

            if (is_match === false) {
                for (let idx = 0; idx < cart_btn_ids.length; idx++) {
                    if (target_ele.closest(`#${cart_btn_ids[idx]}`)){
                        is_match = true
                        break
                    } 
                }
            }

            if (is_match === false) {
                return
            }
            console.log('optimize99_add2cart: ', is_match)
            that.sendCartEvent(views, clid)
        })

    }

    sendCartEvent(views, clid) {

        try {
            let that = this
            let target_clid = utilsHelper.getClidByContainerId(that.storage_key)
            if (clid) {
                target_clid = clid
            }
            // 拿商品資料
            let add_cart_item = null
            for (let idx = dataLayer.length - 1 ; idx > 0; idx --){
              let param = dataLayer[idx]
              if (param[1] !== 'add_to_cart') {
                continue;
              }
              add_cart_item = param[2]
              break;
            }
    
            console.log('optimize99_add_cart_item:', add_cart_item)

            // 如果拿不到item 還是要打，但不帶商品明細
            if (add_cart_item === null) {
                let events = []
                events = views.map(function(view){
                    view = view.view
                    let event = {
                        "container_id": that.container_id,
                        "event": "AddToCart",
                        "event_id": new Date().getTime(),
                        "clid": target_clid,
                        "vid": view.vid,
                        "url": decodeURIComponent(decodeURIComponent(window.location.href)),
                        "value": 0,
                        "content": {}
        
                    }
                    return event
                })

                if (events.length === 0) {
                    // 空的也送
                    let force_event = {
                        "container_id": that.container_id,
                        "event": "AddToCart",
                        "event_id": new Date().getTime(),
                        "clid": target_clid,
                        "vid": "",
                        "url": decodeURIComponent(decodeURIComponent(window.location.href)),
                        "value": 0,
                        "content": {}
                    }
                    // 空的也送
                    that.logHelper.send({
                        "level": 'info',
                        "view": "",
                        "stage": 'trace_shopline_add_cart_force',
                        "request_payload": JSON.stringify(force_event),
                        "api_url": that.config.API_ENDPOINT + '/view/report',
                        "clid": target_clid,
                    })
                    // 空的也送
                    utilsHelper.callAPI(
                        '', 
                        'POST', 
                        that.config.API_ENDPOINT + '/view/report', 
                        force_event
                    ) 
                }


                events.forEach(function(event){

                    that.logHelper.send({
                        "level": 'info',
                        "view": event.vid,
                        "stage": 'trace_shopline_add_cart',
                        "request_payload": JSON.stringify(event),
                        "api_url": that.config.API_ENDPOINT + '/view/report',
                        "clid": target_clid,
                    })
    
                    utilsHelper.callAPI(
                        '', 
                        'POST', 
                        that.config.API_ENDPOINT + '/view/report', 
                        event
                    )
                })

                return
            }
      
            // 總共加入購物車了哪些東西
            let cart_items = []
            cart_items = add_cart_item.items.map(function(item){
                var cart_item = {
                    content_id: item.item_id,
                    content_name: item.item_name,
                    currency: add_cart_item.currency,
                    quantity: item.quantity,
                    price: item.price
                }
                return cart_item
            })
    
            // 總共有幾個view要打事件
            let events = []
            events = views.map(function(view){
                let event = {
                    "container_id": that.container_id,
                    "event": "AddToCart",
                    "event_id": new Date().getTime(),
                    "clid": target_clid,
                    "vid": view.vid,
                    "url": decodeURIComponent(decodeURIComponent(window.location.href)),
                    "value": add_cart_item.value,
                    "content": {
                        original_contents: add_cart_item.items,
                        contents: cart_items,
                        currency: add_cart_item.currency
                    }
    
                }
                return event
            })
    
            console.log('optimize99_add_cart_events', events)
            if (events.length === 0 ) {
                let force_event = {
                    "container_id": that.container_id,
                    "event": "AddToCart",
                    "event_id": new Date().getTime(),
                    "clid": target_clid,
                    "vid": "",
                    "url": decodeURIComponent(decodeURIComponent(window.location.href)),
                    "value": add_cart_item.value,
                    "content": {
                        original_contents: add_cart_item.items,
                        contents: cart_items,
                        currency: add_cart_item.currency
                    }
    
                }

                // 空的也送
                that.logHelper.send({
                    "level": 'info',
                    "view": "",
                    "stage": 'trace_shopline_add_cart_force',
                    "request_payload": JSON.stringify(force_event),
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": target_clid,
                })
                // 空的也送
                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    force_event
                ) 
            }

            // 送事件
            events.forEach(function(event){

                that.logHelper.send({
                    "level": 'info',
                    "view": event.vid,
                    "stage": 'trace_shopline_add_cart',
                    "request_payload": JSON.stringify(event),
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": target_clid,
                })

                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    event
                )
            })
        } catch (error) {
            let target_clid = utilsHelper.getClidByContainerId(that.storage_key)
            if (clid) {
                target_clid = clid
            }
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_shopline_add_to_cart',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                    clid: target_clid
                }
            })
        }
        
    }

    prePlaceOrderBtn(){
        console.log('optimize99_prePlaceOrder')

        let that = this
        const cart_btn_ids = [
            'place-order-btn'
        ]
        const cart_btn_classnames = [
            'btn-place-order'
        ]
        document.addEventListener('click', function(event){
            console.log('click', event)

            let target_ele = event.target
            if (target_ele instanceof HTMLElement === false) {
                if (target_ele.parentElement instanceof HTMLElement === false) {
                    return
                }
                else {
                    target_ele = target_ele.parentElement 
                }
            }


            let is_match = false

            for(let idx = 0; idx < cart_btn_classnames.length; idx++){
                if (target_ele.closest(`.${cart_btn_classnames[idx]}`)){
                    is_match = true
                    break
                } 
            }

            if (is_match === false) {
                for (let idx = 0; idx < cart_btn_ids.length; idx++) {
                    if (target_ele.closest(`#${cart_btn_ids[idx]}`)){
                        is_match = true
                        break
                    } 
                }
            }

            if (is_match === false) {
                return
            }
            console.log('optimize99_prePlaceOrder: ', is_match)
            setTimeout(function(){
                that.prePlaceOrder()
            }, 100)
            
        })
    }

    prePlaceOrder(){

        let that = this
        console.log('optimize99_checkout_preorder')
        let target_clid = ''
        try {
            let clid = utilsHelper.getClidByContainerId(this.storage_key)
            if (clid) {
                target_clid = clid
            }
        } catch (error) {
            target_clid = ''
        }

        try {
            
            // 取訂單資料
            let angular_params = window.app._invokeQueue;
            let angular_params_len = window.app._invokeQueue.length - 1;
            let cart = null
            for(var idx = 0; idx <= angular_params_len; idx++ ) {
                if (!angular_params[idx]) {
                    break;
                }
                if(angular_params[idx][2][0] !== 'cart') {
                    continue;
                }
                cart = angular_params[idx][2][1];
            }

            console.log('optimize99_checkout_cart', cart)

            // 建立購買的商品
            let products = cart.items.map(function(item){
                let product = {}

                // 用來找看過哪些view的product_id都用平台id
                product['content_id'] = item.product_id

                // 商品真正的sku
                if (item.variation) {
                    if (item.variation.sku) {
                        product['content_sku'] = item.variation.sku
                    }
                    else {
                        product['content_sku'] = item.product_id
                    }
                }
                else {
                    if (item.product.sku) {
                        product['content_sku'] = item.product.sku
                    }
                    else {
                        product['content_sku'] = item.product_id
                    }
                }

                product['content_name'] = item.product.title_translations['zh-hant']

                product['currency'] = cart.total.currency_iso
                product['quantity'] = item.quantity
                
                if (item.variation) {
                    if (item.variation.price_sale && item.variation.price_sale.cents) {
                        product['price'] = item.variation.price_sale.cents
                    }
                    else {
                        product['price'] = item.variation.price.cents
                    }
                }
                else {
                    if (item.product.price_sale && item.product.price_sale.cents) {
                        product['price'] = item.product.price_sale.cents
                    }
                    else {
                        if (item.product && item.product.price) {
                            product['price'] = item.product.price.cents
                        }
                        else {
                            product['price'] = 0
                        }
                        
                    }
                }

                return product
            })

            console.log('optimize99_checkout_products', products)

            // 用購買的商品挑出最近有看過的view
            let recent_seen_views = []
            let container_storage = JSON.parse(localStorage.getItem(this.storage_key))
            products.forEach(function(product){
                if (container_storage['view_product'][product.content_id]) {
                    let product_views = Object.keys(container_storage['view_product'][product.content_id])
                    for (let idx = 0 ; idx < product_views.length; idx++) {
                        let view = container_storage['view_product'][product.content_id][product_views[idx]]
                        let last_view_at = view.last_view_at
                        let now = new Date().getTime()
                        let duration = now - parseInt(last_view_at)
                        let expired_time = 1000 * 60 * that.expired_min
                        if (duration < expired_time) {
                            if (recent_seen_views.includes(product_views[idx]) === false) {
                                recent_seen_views.push(product_views[idx])
                            }
                        }
                        else {
                            delete container_storage['view_product'][product.content_id][product_views[idx]]
                        }

                    }
                }
            })

            console.log('optimize99_checkout_recent_seen_views ', recent_seen_views)

            // 取email
            let email = ''
            let labelElement = document.querySelector('label[for="order-customer-email"]');
            let parent = labelElement.parentElement.querySelector('input')
            if (parent) {
                email = parent.value
            }
            else {
                email = labelElement.parentElement.querySelector('p').textContent.replace(/' |\r|\n'/g, '')
            }

            let email_account = email.split('@')[0]
            let tmp_email = email_account.substring(0, email_account.length - 3) + '****'
            let hash_email = tmp_email + '@' + email.split('@')[1]

            // clid
            let events = []
            events = recent_seen_views.map(function(view_id){
                let event = {
                    "container_id": that.container_id,
                    "event": "PlaceAnOrder",
                    "event_id": 'tmp-' + new Date().getTime(),
                    "clid": target_clid,
                    "vid": view_id,
                    "domain": window.location.hostname,
                    "email": hash_email,
                    "url": window.location.href,
                    "value": cart.total.cents,
                    "content": {
                        contents: products,
                        currency: cart.total.currency_iso
                    }
                }
                return event
            })
            that.logHelper.send({
                "level": 'info',
                "stage": 'trace_shopline_prePlaceOrder_before',
                "request_payload": events,
                "api_url": that.config.API_ENDPOINT + '/view/report',
                "clid": target_clid,
            })
            console.log('optimize99_checkout_events ', events)
            let plugin_event = {}
            try {
                let pagePlugin = new PagePlugin(
                    this.container_id, this.config
                )
                plugin_event = pagePlugin.purchaseEvent(products)
            } catch (error) {
                console.log('purchase_plugin_error:', error)
            }
            console.log('purchase_plugin_event:', plugin_event)
            // 如果是空的，也打事件
            if (events.length === 0) {

                let force_event = {
                    "container_id": that.container_id,
                    "event": "PlaceAnOrder",
                    "event_id": 'tmp-' + new Date().getTime(),
                    "clid": target_clid,
                    "vid": "",
                    "domain": window.location.hostname,
                    "email": hash_email,
                    "url": window.location.href,
                    "value": cart.total.cents,
                    "content": {
                        contents: products,
                        currency: cart.total.currency_iso
                    }
                }
                if (plugin_event['sales_counter'] && plugin_event['sales_counter'].length > 0) {
                    force_event["content"]['sales_counter'] = plugin_event['sales_counter']
                }

                that.logHelper.send({
                    "level": 'info',
                    "view": "",
                    "stage": 'trace_shopline_prePlaceOrder_force',
                    "request_payload": force_event,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": target_clid,
                })

                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    force_event
                )

            }

            events.forEach(function(event, event_idx){
                if (plugin_event['sales_counter'] && plugin_event['sales_counter'].length > 0 && event_idx === 0) {
                    event["content"]['sales_counter'] = plugin_event['sales_counter']
                }

                that.logHelper.send({
                    "level": 'info',
                    "view": event.vid,
                    "stage": 'trace_shopline_prePlaceOrder',
                    "request_payload": event,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": target_clid,
                })

                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    event
                )
            })

            localStorage.setItem(this.storage_key, JSON.stringify(container_storage))
        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_shopline_prePlaceOrder',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                    target_clid: target_clid
                }
            })
        }
    }

    async confirmOrder(clid) {
        let that = this
        console.log('optimize99_confirm_order')
        try {

            let order_id_str = utilsHelper.extractNumbers(document.querySelector('.confirm-message > h4').nextSibling.textContent)
            order_id_str = order_id_str[0]
            let total_str = utilsHelper.extractNumbers(document.querySelector('.total-text').innerText)
            total_str = total_str[0]

            let hash_email = document.querySelector('.confirm-message').getElementsByTagName('b')[0].textContent.replace(/ |\n|\r/g,'')
            // 取訂單資料
            let angular_params = window.app._invokeQueue;
            let angular_params_len = window.app._invokeQueue.length - 1;
            let order = null

            for (let retry_idx = 0 ; retry_idx <= this.retry_time; retry_idx++) {
                for(var idx = 0; idx <= angular_params_len; idx++ ) {
                    if (!angular_params[idx]) {
                      break
                    }
                    if(angular_params[idx][2][0] !== 'order') {
                      continue;
                    }
                    order = angular_params[idx][2][1];
                }

                if (order) {
                    break;
                }
                else {
                    await utilsHelper.sleep(500);
                }
            }


            let order_data = {}
            if (!order) {
                order_data = {
                    "container_id": that.container_id,
                    "domain": window.location.hostname,
                    "email": hash_email,
                    "value": total_str,
                    "order_id": order_id_str
                }

            }
            else {
                order_data = {
                    "container_id": that.container_id,
                    "domain": window.location.hostname,
                    "email": hash_email,
                    "value": order.total.cents,
                    "order_id": order.order_number
                }
            }

            // 沒有clid的情形(跳轉新瀏覽器)
            console.log('optimize99_confirm_order_no_clid')
            
            that.logHelper.send({
                "level": 'info',
                "stage": 'trace_shopline_confirmOrder_no_clid',
                "request_payload": order_data,
                "api_url": that.config.API_ENDPOINT + '/view/complete',
            })

            await utilsHelper.callAPI(
                '', 
                'POST', 
                this.config.API_ENDPOINT + '/view/complete', 
                order_data
            )
    
            // 有clid的情形(無跳轉)
            console.log('optimize99_confirm_order_clid', clid)
            console.log('optimize99_confirm_order_order', order)
    
            // 建立購買的商品
            let products = order.subtotal_items.map(function(item){
                let product = {}
    
                // 用來找看過哪些view的product_id都用平台id
                product['content_id'] = item.item_id
    
                // 商品真正的sku
                if (item.item_data.variation_data) {
                    if (item.item_data.variation_data.sku) {
                        product['content_sku'] = item.item_data.variation_data.sku
                    }
                    else {
                        product['content_sku'] = item.item_id
                    }
                }
                else {
                    if (item.object_data.sku) {
                        product['content_sku'] = item.object_data.sku
                    }
                    else {
                        product['content_sku'] = item.item_id
                    }
                }
    
                product['content_name'] = item.object_data.title_translations['zh-hant']
    
                product['currency'] = order.total.currency_iso
                product['quantity'] = item.quantity
                
                if (item.item_data.variation_data) {
                    if (item.item_data.variation_data.price_sale && item.item_data.variation_data.price_sale.cents) {
                        product['price'] = item.item_data.variation_data.price_sale.cents
                    }
                    else {
                        product['price'] = item.item_data.variation_data.price.cents
                    }
                }
                else {
                    if (item.object_data.price_sale && item.object_data.price_sale.cents) {
                        product['price'] = item.object_data.price_sale.cents
                    }
                    else {
                        product['price'] = item.object_data.price.cents
                    }
                }
    
                return product
            })
    
            console.log('optimize99_confirm_order_products', products)
    
            // 用購買的商品挑出最近有看過的view
            let recent_seen_views = []
            let container_storage = JSON.parse(localStorage.getItem(this.storage_key))
            products.forEach(function(product) {
                if (container_storage['view_product'][product.content_id]) {
                    let product_views = Object.keys(container_storage['view_product'][product.content_id])
                    for (let idx = 0 ; idx < product_views.length; idx++) {
                        let view = container_storage['view_product'][product.content_id][product_views[idx]]
                        let last_view_at = view.last_view_at
                        let now = new Date().getTime()
                        let duration = now - parseInt(last_view_at)
                        let expired_time = 1000 * 60 * that.expired_min
                        if (duration < expired_time) {
                            if (recent_seen_views.includes(product_views[idx]) === false) {
                                recent_seen_views.push(product_views[idx])
                            }
                        }
                        else {
                            delete container_storage['view_product'][product.content_id][product_views[idx]]
                        }
    
                    }
                }
            })
    
            console.log('optimize99_confirm_order_recent_seen_views ', recent_seen_views)
    
            let events = []
            events = recent_seen_views.map(function(recent_seen_view){
                let event = {
                    "container_id": that.container_id,
                    "event": "PlaceAnOrder",
                    "event_id": order.order_number,
                    "clid": clid,
                    "vid": recent_seen_view,
                    "url": decodeURIComponent(window.location.href),
                    "value": order.total.cents,
                    "content": {
                        contents: products,
                        currency: order.total.currency_iso
                    }
                }
                return event
            })
    
            console.log('optimize99_confirm_order_events:', events)
            let plugin_event = {}
            try {
                let pagePlugin = new PagePlugin(
                    this.container_id, this.config
                )
                plugin_event = pagePlugin.purchaseEvent(products)
            } catch (error) {
                console.log('purchase_plugin_error:', error)
            }
            console.log('purchase_plugin_event:', plugin_event)
            if (events.length === 0) {
                let force_event = {
                    "container_id": that.container_id,
                    "event": "PlaceAnOrder",
                    "event_id": order.order_number,
                    "clid": clid,
                    "vid": "",
                    "url": decodeURIComponent(window.location.href),
                    "value": order.total.cents,
                    "content": {
                        contents: products,
                        currency: order.total.currency_iso
                    }
                }
                if (plugin_event['sales_counter'] && plugin_event['sales_counter'].length > 0) {
                    force_event["content"]['sales_counter'] = plugin_event['sales_counter']
                }

                that.logHelper.send({
                    "level": 'info',
                    "view": "",
                    "stage": 'trace_shopline_confirmOrder_force',
                    "request_payload": force_event,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": clid,
                })

                force_event['container_id'] = this.container_id

                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    force_event
                )
            }
    
            events.forEach(function(event, event_idx){
                
                if (plugin_event['sales_counter'] && plugin_event['sales_counter'].length > 0 && event_idx === 0) {
                    event["content"]['sales_counter'] = plugin_event['sales_counter']
                }
                that.logHelper.send({
                    "level": 'info',
                    "view": event.vid,
                    "stage": 'trace_shopline_confirmOrder',
                    "request_payload": event,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": clid,
                })
                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    event
                )
            })
    
            recent_seen_views.forEach(function(recent_seen_view){
                products.forEach(function(product) {
                    if (container_storage['view_product'][product.content_id] && container_storage['view_product'][product.content_id][recent_seen_view]) {
                        delete container_storage['view_product'][product.content_id][recent_seen_view]
                    }
                })
            })
    
            localStorage.setItem(this.storage_key, JSON.stringify(container_storage))
            console.log('optimize99_confirm_order_container_storage:', container_storage)
        } catch (error) {
            console.log('confirmOrder_error', error)
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_shopline_confirmOrder',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                    target_clid: clid
                }
            })
        }
    }
}